import { createFileRoute } from "@tanstack/react-router";

import { MarpTemplateSettings } from "@/features/settings";

/**
 * ``/settings/marp-templates`` — custom Marp deck template manager (Wave 4).
 *
 * Two-section surface:
 *   - CSS string upload (slug + description + scope + raw CSS textarea)
 *   - Import-from-PowerPoint (`.pptx` upload → BE extracts tokens → preview
 *     → "Modifica nome e salva" lifts the result into the CSS section)
 *
 * Backed by the Wave 4 BE-Templates endpoints
 * (`/api/v1/templates/marp/upload-css` and `.../extract-from-pptx`). Mounted
 * under the modal-settings shell so the rail nav stays consistent with the
 * existing settings surfaces (Profilo / Sicurezza / Presentations ...).
 *
 * The route is reachable from:
 *   - the `<MarpTemplatePicker>` "Carica tuo template..." footer item
 *     inside the deck editor (`MarpDeckEditorMount`)
 *   - any future direct link from the Settings rail (Wave 4 backlog —
 *     add an entry to the `NAV_GROUPS["Esperienza"]` in
 *     `_authed/_modal/settings/route.tsx` once the BE endpoints land).
 */
export const Route = createFileRoute(
  "/_authed/_modal/settings/marp-templates",
)({
  component: MarpTemplateSettings,
});
